module.exports = ".responsive-profile-img {\n  width: 100%;\n  float: left;\n  margin-right: 10px;\n  height: 100px;\n  margin-bottom: 10px; }\n\n.current-one {\n  background-color: #f8fafb !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/profile/profile.component.scss
// module id = ./src/app/seller/profile/profile.component.scss
// module chunks = main